import { Component, OnInit } from '@angular/core';
import { TbModoPrestacao } from '../model/tb-modo-prestacao.model';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { DataTableColumn } from 'app/shared/components/data-table/model/data-table-column.model';
import { DataControl } from 'app/shared/components/data-table/model/data-control.model';

@Component({
  selector: 'siscoserv-modo-prestacao',
  templateUrl: './modo-prestacao.component.html',
  styleUrls: ['./modo-prestacao.component.scss'],
  providers: [CrudService]
})
export class ModoPrestacaoComponent extends DataTableBasicComponent implements OnInit {
  public tbModoPrestacao: TbModoPrestacao = new TbModoPrestacao();

  constructor(crudService: CrudService) {
    super(crudService);
  }

  ngOnInit() {
    this.columns = [
      new DataTableColumn('CÓDIGO', 'cod'),
      new DataTableColumn('DESCRIÇÃO', 'descricao'),
      new DataTableColumn('CÓDIGO*', 'valueAlias')
    ];

    this.controls = [
      new DataControl('Código', 'cod').setReadOnly(),
      new DataControl('Descrição', 'descricao').setReadOnly(),
      new DataControl('Código*', 'valueAlias')
    ];
  }
}
